import validate from 'validate.js'

// We have to return an object for redux-form
// but validate.js returns null when everything passes
export let syncValidate = (values, constraints, ...arrayFields) => {
  var result = validate(values, constraints) || {}
  result = Object.keys(result).reduce((obj, prop) => {
    obj[prop] = result[prop].join(', ')
    return obj
  }, {})

  arrayFields.forEach(field => {
    if (result[field]) {
      result[field] = { _error: result[field] }
    }
  })

  return result
}

validate.validators.uniqueItems = (value, options, key, attributes) => {
  if (!value) return
  if (!Array.isArray(value)) throw new Error('uniqueItems validator requires an array value')
  if (!value.every((val, index) => index === value.indexOf(val))) return 'cannot contain duplicates'
}

validate.validators.arrayItems = (value, options, key, attributes) => {
  if (!value || !value.length) return null
  let result = options.predicate(value)
  if (!result) return null
  if (typeof result === 'string') return result
  return options.message || 'invalid item'
}

export let hasErrors = (obj) => Object.keys(obj).length

// TODO: REMOVE THIS ONCE REDUX-FORM FIXES THEIR SUBMIT VALIDATION
export let submitIfValid = (props, transformer) => props.handleSubmit((result) => {
  if (!hasErrors(props.validate(result))) return props.onSubmit(transformer ? transformer(result) : result)
})

// TODO: Make async wrapper when you have a use case for validate.async

// eslint-disable-next-line
export const isUrl = (value) => value && value.match(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/) !== null



// WEBPACK FOOTER //
// ./client/src/util/validation.js